import {BaseApiService} from "../../../StarterKit/Service/BaseApiService";


export default class ApiObjectif extends BaseApiService {


    async list() {
        this.setGetMethod();
        this.setSecureByUser();
        this.setApiRoute(sessionStorage['language'] + "/objectif");
        return await this.callApi();
    }

    async listAll() {
        this.setGetMethod();
        this.setSecureByUser();
        this.setApiRoute(sessionStorage['language'] + "/objectif");
        return await this.callApi();
    }

    async import(file) {
        this.setPostMethod();
        this.setSecureByUser();
        this.callNeedFileInBody();
        this.setFile(file);
        this.setShowReturn();
        this.setApiRoute(sessionStorage['language'] + "/objectif/import?force=true");
        return await this.callApi();
    }

    async importCommerciaux(file) {
        this.setPostMethod();
        this.setSecureByUser();
        this.callNeedFileInBody();
        this.setFile(file);
        this.setShowReturn();
        this.setApiRoute(sessionStorage['language'] + "/objectif/importcomm?force=true");
        return await this.callApi();
    }

}
